module.exports = __webpack_public_path__ + "img/coins-3.d0438f93.png";